module.exports = __webpack_public_path__ + "static/media/autochilango-pin.cd001704.svg";